import { Circle, GeometryForm, Rect } from 'src/types';

import { clamp } from './clamp';

const hasIntersectionBetweenRects = (first: Rect, second: Rect): boolean => {
  return (
    first.left < second.right &&
    first.right > second.left &&
    first.top < second.bottom &&
    first.bottom > second.top
  );
};

const hasIntersectionBetweenRectAndCircle = (
  rect: Rect,
  circle: Circle,
): boolean => {
  const closestX = clamp(circle.x, rect.left, rect.right);
  const closestY = clamp(circle.y, rect.top, rect.bottom);

  const distanceX = circle.x - closestX;
  const distanceY = circle.y - closestY;

  const distanceSquared = distanceX ** 2 + distanceY ** 2;

  return distanceSquared < circle.radius ** 2;
};

const hasIntersectionBetweenCircles = (
  first: Circle,
  second: Circle,
): boolean => {
  const distance =
    ((first.x - second.x) ** 2 + (first.y - second.y) ** 2) ** 0.5;

  return distance <= first.radius + second.radius;
};

export const hasIntersection = (
  first: GeometryForm,
  second: GeometryForm,
): boolean => {
  if (first.type === 'rect') {
    if (second.type === 'rect') {
      return hasIntersectionBetweenRects(first, second);
    }
    return hasIntersectionBetweenRectAndCircle(first, second);
  }
  if (second.type === 'rect') {
    return hasIntersectionBetweenRectAndCircle(second, first);
  }
  return hasIntersectionBetweenCircles(first, second);
};
